import { render, staticRenderFns } from "./global-code-dialog.vue?vue&type=template&id=e8f9cc62&scoped=true&"
import script from "./global-code-dialog.vue?vue&type=script&lang=js&"
export * from "./global-code-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f9cc62",
  null
  
)

export default component.exports